import React from 'react';

const CotacaoMoedaContext = React.createContext();

export default CotacaoMoedaContext;
